import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { hasCustomerInfo } from '../../../helpers/customerParser';

function CustomerCell({ customer, delivery }) {
  const buyerName = `${customer?.firstName || ''} ${
    customer?.lastName || ''
  }`.trim();
  const receiverName = delivery?.receiverName;
  const isDifferentRecipient =
    receiverName && receiverName.toLowerCase() !== buyerName.toLowerCase();

  if (!hasCustomerInfo(customer)) {
    return <Typography variant="caption">Desconocido</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="caption">{buyerName}</Typography>
      <Typography variant="caption">
        {customer.email} {customer.phone}
      </Typography>
      {isDifferentRecipient && (
        <Box sx={{ mt: 0.5 }}>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 'bold',
              display: 'block',
            }}
          >
            Recibe:
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: 'text.secondary', display: 'block' }}
          >
            {receiverName}
          </Typography>
          {delivery?.receiverPhone && (
            <Typography
              variant="caption"
              sx={{ color: 'text.secondary', display: 'block' }}
            >
              {delivery.receiverPhone}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

CustomerCell.propTypes = {
  customer: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  delivery: PropTypes.shape({
    receiverName: PropTypes.string,
    receiverPhone: PropTypes.string,
  }),
};

CustomerCell.defaultProps = {
  delivery: null,
};

export default CustomerCell;
